"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedovercastsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedovercastsm` : '') + (description ? ` desc-brandedovercastsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedovercastsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedovercastsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.74 6.13 9.87 7.19a.33.33 0 0 0-.16.37l.57 2.08a.33.33 0 0 1-.4.4L7.8 9.49a.33.33 0 0 0-.38.15l-1.06 1.88a.33.33 0 0 1-.58 0L4.72 9.63a.33.33 0 0 0-.38-.15l-2.07.57a.33.33 0 0 1-.41-.41l.57-2.08a.33.33 0 0 0-.16-.37L.4 6.13a.33.33 0 0 1 0-.58l1.87-1.06c.13-.08.2-.24.16-.38l-.57-2.08a.33.33 0 0 1 .4-.4l2.08.57c.15.04.3-.03.38-.16L5.78.17a.33.33 0 0 1 .58 0l1.06 1.87c.08.13.23.2.38.16l2.07-.58c.25-.06.48.16.41.41l-.57 2.08c-.04.15.02.3.16.38l1.87 1.06c.22.12.22.45 0 .58Z",
    fill: "#F7B941"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.07 9.45a3.61 3.61 0 1 0 0-7.23 3.61 3.61 0 0 0 0 7.23Z",
    fill: "#FFDC9C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.97 10.56c0-1.53-1.1-2.8-2.55-3.08a4.68 4.68 0 0 0-8.3-.62 3.57 3.57 0 0 0-5.55 1.92C1.77 8.32 0 9.54 0 11.18c0 1.65 1.72 2.86 3.54 2.42a2.8 2.8 0 0 0 4.56.3 4.98 4.98 0 0 0 8.87-.22c1.66-.06 3-1.43 3-3.12Z",
    fill: "#D4D4D4"
  }));
};
var _default = exports.default = brandedovercastsm;